import ToolButton from 'components/buttons/ToolButton';
import React, { memo } from 'react';

const RefundField = (props) => {
  const { record, onRefund, currencyCode } = props;

  const isRefunded =
    record?.transactions &&
    record.transactions[0]?.details?.receiptDetails?.refundStatus === 'succeeded';

  const isCurrency =
    record?.transactions && record.transactions[0]?.amount?.currency === currencyCode;
  if (record.type !== 'DEPOSIT' || record?.status !== 'CONFIRMED' || isRefunded || !isCurrency)
    return null;

  return <ToolButton onClick={() => onRefund(record)}>Refund</ToolButton>;
};

export default memo(RefundField);
